import { useRef } from 'react';
import { useAsset } from '@artica/assets';
import { useFrame } from '@react-three/fiber';

export default function Flocking() {
  const {
    nodes,
    materials,
  } = useAsset('dyson');

  const ref = useRef();

  useFrame(() => {
    const obj = ref.current;
    if (!obj) return;

    obj.rotation.y = obj.rotation.y + 0.0015 / Math.PI;
    obj.rotation.z = obj.rotation.z + 0.0015 / Math.PI;
  });

  return (
    <mesh
      ref={ ref }
      name="Flocking"
      geometry={ nodes.Flocking.geometry }
      material={ materials.flockingmat }
      rotation={ [-1.15, -0.38, -0.07] }
    />
  );
};